import { render, staticRenderFns } from "./MailCredentialsForm.vue?vue&type=template&id=e0fc48bc&scoped=true&"
import script from "./MailCredentialsForm.vue?vue&type=script&lang=js&"
export * from "./MailCredentialsForm.vue?vue&type=script&lang=js&"
import style0 from "./MailCredentialsForm.vue?vue&type=style&index=0&id=e0fc48bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fc48bc",
  null
  
)

export default component.exports